import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross8X8 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 6L14 14",
		stroke: "white",
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 14L14 5.99999",
		stroke: "white",
		strokeLinecap: "round"
	})]
});
export default SvgCross8X8;
